const DEVICE_KEY = 'nexo_device_id';
const SESSION_KEY = 'nexo_session_id';
const SESSION_STARTED_AT_KEY = 'nexo_session_started_at_ms';

function safeStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // storage no disponible
  }
}

function safeStorageRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // storage no disponible
  }
}

function keysForUid(uid) {
  if (!uid) {
    return { session: SESSION_KEY, startedAt: SESSION_STARTED_AT_KEY };
  }
  return {
    session: `${SESSION_KEY}_${uid}`,
    startedAt: `${SESSION_STARTED_AT_KEY}_${uid}`
  };
}

function migrateLegacySession(uid) {
  if (!uid) return;
  const { session, startedAt } = keysForUid(uid);
  const legacySession = safeStorageGet(SESSION_KEY);
  const legacyStarted = safeStorageGet(SESSION_STARTED_AT_KEY);
  if (!safeStorageGet(session) && legacySession) {
    safeStorageSet(session, legacySession);
    if (legacyStarted) safeStorageSet(startedAt, legacyStarted);
  }
}

function randomId(prefix) {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return `${prefix}_${crypto.randomUUID()}`;
    }
  } catch {
    // fallback
  }
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export function ensureDeviceId() {
  const existing = safeStorageGet(DEVICE_KEY);
  if (existing) return existing;
  const next = randomId('dev');
  safeStorageSet(DEVICE_KEY, next);
  return next;
}

export function ensureSessionId(uid) {
  migrateLegacySession(uid);
  const { session, startedAt } = keysForUid(uid);
  const existing = safeStorageGet(session);
  if (existing) {
    const started = safeStorageGet(startedAt);
    if (!started) safeStorageSet(startedAt, String(Date.now()));
    return existing;
  }
  const next = randomId('ses');
  safeStorageSet(session, next);
  safeStorageSet(startedAt, String(Date.now()));
  return next;
}

export function rotateSessionId(uid) {
  const { session, startedAt } = keysForUid(uid);
  const next = randomId('ses');
  safeStorageSet(session, next);
  safeStorageSet(startedAt, String(Date.now()));
  return next;
}

export function clearSessionId(uid) {
  if (uid) {
    const { session, startedAt } = keysForUid(uid);
    safeStorageRemove(session);
    safeStorageRemove(startedAt);
  }
  safeStorageRemove(SESSION_KEY);
  safeStorageRemove(SESSION_STARTED_AT_KEY);
}

export function getSessionStartedAtMs(uid) {
  const { session, startedAt } = keysForUid(uid);
  const raw = safeStorageGet(startedAt);
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) {
    if (!safeStorageGet(session)) return null;
    const now = Date.now();
    safeStorageSet(startedAt, String(now));
    return now;
  }
  return n;
}
